import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectAccount } from './account.selector.ts';

export const selectAccountEmail = createMemoizedSelector(
  selectAccount,
  (currentAccount): string | undefined => currentAccount?.email
);
